import { IWidget } from 'core-components/sitebuilder/models/IWidget'

export interface IWidgetTypeValue {
  type: Exclude<keyof IWidget['type'], undefined>
  createNewWidgetHeaderText: string
  createNewWidgetButtonText: string
}

export const WidgetTypes: Record<Exclude<keyof IWidget['type'], undefined>, IWidgetTypeValue> = {
  Static: {
    type: 'Static',
    createNewWidgetHeaderText: 'Create new Content widget',
    createNewWidgetButtonText: 'Add Content Widget',
  },
  Iframe: {
    type: 'Iframe',
    createNewWidgetHeaderText: 'Create new Iframe widget',
    createNewWidgetButtonText: 'Add IFrame Widget',
  },
  React: {
    type: 'React',
    createNewWidgetHeaderText: 'Create new React widget',
    createNewWidgetButtonText: 'Add React Widget',
  },
  FromLibrary: {
    type: 'FromLibrary',
    createNewWidgetHeaderText: 'Choose Widget from Library',
    createNewWidgetButtonText: 'Add Widget from library',
  },
}
